<template>
  <div class="slideshow-container" :class="{ 'clickable': clickable }" :style="{ '--slide-height': `${height}px` }">
    <slot></slot>
    <div class="slides">
      <div class="slide" v-for="(image, index) in images" :key="index">
        <img :src="`${cloudfrontUrl}${image.id}/STREAM_EVENT_SMALL`" :alt="'Slide ' + (index + 1)" />
      </div>
    </div>
    <v-row>
      <v-col cols="auto" md="8" class="text-left custom-card-title" style="text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;">{{ title }}</v-col>
      <v-col align="end"> {{ formatDate(event.eventStartDate) }} - {{ formatDate(event.eventEndDate) }}</v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    height: {
      type: Number,
      default: 200
    },
    images: {
      type: Array,
      default: () => [
        'https://via.placeholder.com/600x300?text=Image+1',
        'https://via.placeholder.com/600x300?text=Image+2',
        'https://via.placeholder.com/600x300?text=Image+3',
        'https://via.placeholder.com/600x300?text=Image+4',
      ]
    },
    event: {
      type: Object,
      required: false
    },
    clickable: {
      type: Boolean,
      default: false
    }

  },

  data() {
    return {
      cloudfrontUrl: process.env.VUE_APP_CLOUDFRONT_BASE_URL,
      currentSlide: 0,
      // images: [
      //   'https://via.placeholder.com/600x300?text=Image+1',
      //   'https://via.placeholder.com/600x300?text=Image+2',
      //   'https://via.placeholder.com/600x300?text=Image+3',
      //   'https://via.placeholder.com/600x300?text=Image+4',
      // ],
    };
  },
  methods: {
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      return `${day}.${month}`;
    }
  },
};
</script>

<style scoped>
.slideshow-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.slides {
  display: flex;
  transition: transform 1s ease-in-out;
}

.slide {
  min-width: 100%;
  height: var(--slide-height, 200px);
  /* You can adjust this height or make it dynamic */
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.custom-card-title {
  font-weight: 400;
  font-size: 12pt;
}
</style>